module.exports = __webpack_public_path__ + "img/bg_line4.765baeba.png";